import axios from 'axios';

const API_BASE = '/api/ui-theme';

export const uiThemeService = {
  get: async () => {
    const response = await axios.get(API_BASE);
    return response.data;
  },
  update: async (preset) => {
    const response = await axios.put(API_BASE, { preset });
    return response.data;
  },
};
